import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'adc-autocomplete',
  templateUrl: './adc-autocomplete.component.html',
  styleUrls: ['./adc-autocomplete.component.scss'],
  standalone: false,
  host: {
    "(window:click)": "onClick()"
  }
})
export class AdcAutocompleteComponent {
  @Input() data: any;
  @Input() inputStyle: any;
  @Output() selectedData = new EventEmitter();
  showList: boolean = false;
  showList2: boolean = false;
  showIcon: boolean = false;
  searchInput = '';
  searchInput2 = '';
  suggestions: string[] = [];
  list: string[] = [];
  selectedTags: any[] = [];
  @ViewChild('searchInput') searchInputElement!: ElementRef;

  ngOnInit() {
    for(let i of this.data.list) {
      this.list.push(i.label);
    }
  }

  data_: any = {
    "id": "1",
    "theme": "blue",
    "type": "basic",
    "placeHolder": "Type to search",
    "icon": "search",
    "list": [
      {
        "id": "1",
        "name": "disputeManager",
        "label": "Dispute Manager"
      },
      {
        "id": "2",
        "name": "fraudManager",
        "label": "Fraud Manager"
      },
      {
        "id": "3",
        "name": "complaintsManager",
        "label": "Complaints Manager"
      },
      {
        "id": "4",
        "name": "alertManager",
        "label": "Complaints Manager"
      },
      {
        "id": "5",
        "name": "BsaManager",
        "label": "BSA Manager"
      },
      {
        "id": "6",
        "name": "workflowManager",
        "label": "Workflow Manager"
      },
      {
        "id": "7",
        "name": "caseManagement",
        "label": "Case Management"
      },
      {
        "id": "8",
        "name": "claimsManager",
        "label": "Claims Manager"
      },
      {
        "id": "9",
        "name": "businessAnalytics",
        "label": "Business Analytics"
      },
    ]
  }
  

  onInputChange(event: any): void {
    event.stopPropagation();
    this.showIcon = true;
    const searchText = event.target.value.toLowerCase();
    this.showList = true;
    this.suggestions = this.list.filter((val:any) =>
      val.toLowerCase().includes(searchText)
    );
  }

  onInputChange2(event: any) {
    event.stopPropagation();
    const searchText = event.target.value.toLowerCase();
    this.showList2 = true;
    this.suggestions = this.list.filter(val =>
      val.toLowerCase().includes(searchText)
    );
  }

  onSuggestionClick(suggestion: string): void {
      this.searchInput = suggestion;
      this.selectedData.emit(this.searchInput);
      this.showList = false;
      this.suggestions = [];
      this.showIcon = false;
  }

  onSuggestionClick2(suggestion: string) {
    this.searchInput2 = '';
    this.addTag(suggestion);
    this.showList2 = false;
  }

  onClick() {
    this.showList = false;
    this.showIcon = false;
  }

  clearSearch() {
    this.searchInput = '';
  }

  focusInput() {
    this.searchInputElement.nativeElement.focus();
  }

  addTag(tag: string): void {
    if (!this.selectedTags.includes(tag)) {
      this.selectedTags.push(tag);
    }
    this.selectedData.emit(this.selectedTags);
  }

  removeTag(tag: string): void {
    this.selectedTags = this.selectedTags.filter(t => t !== tag);
  }

  //key events
  selectedIndex = -1;

  navigateOptions(direction: number) {
    this.selectedIndex = (this.selectedIndex + direction + this.suggestions.length) % this.suggestions.length;
  }

  onKeydown(event: KeyboardEvent) {
    if (this.suggestions.length > 0) {
      // Handle 'ArrowDown' key press
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        if (this.selectedIndex < this.suggestions.length - 1) {
          this.selectedIndex++;
        } else {
          this.selectedIndex = 0; // Loop back to the first suggestion
        }
      }
  
      // Handle 'ArrowUp' key press
      if (event.key === 'ArrowUp') {
        event.preventDefault();
        if (this.selectedIndex > 0) {
          this.selectedIndex--;
        } else {
          this.selectedIndex = this.suggestions.length - 1; // Loop back to the last suggestion
        }
      }
  
      // Handle 'Enter' key press
      if (event.key === 'Enter' && this.selectedIndex > -1) {
        event.preventDefault();
        this.onSuggestionClick2(this.suggestions[this.selectedIndex]);
      }

      // Handle 'Escape' key press to close the dropdown
      if (event.key === 'Escape') {
        this.showList2 = false;
      }

    }
  }
  
  selectOption() {
    if (this.selectedIndex >= 0) {
      this.closeDropdown();
    }
  }

  closeDropdown() {
    this.showList2 = false;
    this.selectedIndex = -1;
  }

}
